import api from "@/apis/revenuemanagement/RevenueManagementAPI";
import Crud from "@/stores/crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("revenuemanagement", api);

const state = {
  ...crud.state,
  /**
   * Cấu hình của module
   */
  _config: {
    field: {
      key: "id",
    },
  },

  data: [],
};

const getters = {
  ...crud.getters,
};

const actions = {
  ...crud.actions,
};

const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
